<script setup lang="ts">
import { RouterView } from 'vue-router';
import ToastCustom from './components/ToastCustom.vue';
import { useAuthStore } from './stores/auth/auth.slice';

// Créé dans un composant, le store charge le jeton enregistré au montage ;
// sans cela, les gardes de route attendent indéfiniment.
useAuthStore();
</script>

<template>
  <ToastCustom />
  <RouterView />
</template>
